import { Col } from 'antd';
import { ContactForm } from './ContactForm';

export const Contact = () => {
  return (
    <Col xl={6} xs={12} style={{ margin: 'auto' }}>
      <div>
        <div>
          <ContactForm />
        </div>
      </div>
    </Col>
  );
};
